module.exports = __webpack_public_path__ + "img/vision.ff368ab1.png";